import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'

import { mediaEntityUploadService } from 'src/services/media-entity-upload.service'
import ProductService from 'src/services/product.service'
import { IProductUpdateFormDto } from 'src/types/product.type'

import { QUERY_KEYS } from 'src/constants'

const useEditProduct = () => {
  const queryClient = useQueryClient()
  const { id } = useParams()

  return useMutation(
    async ({ media, image, oldImage, oldMedia, ...product }: IProductUpdateFormDto) => {
      const updatedImage = await mediaEntityUploadService.updateIcon(oldImage, image)
      const updatedMedia = await mediaEntityUploadService.updateMedia(oldMedia, media)

      return await ProductService.editProduct(
        {
          ...product,
          selectedJourney: product.selectedJourney || null,
          gtin: product.gtin || null,
          image: updatedImage ? updatedImage[0] : image.icon,
          image_small: updatedImage ? updatedImage[1] || null : product.image_small,
          image_medium: updatedImage ? updatedImage[2] || null : product.image_medium,
          media: updatedMedia,
        },
        id!,
      )
    },
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_KEYS.GET_PRODUCT, id])
        queryClient.refetchQueries([QUERY_KEYS.GET_IMPACT])
      },
    },
  )
}

export { useEditProduct }
